<template>
  <div class="student_box student_bg">
    <header class="flex-align-between student-head">
      <img src="@/assets/student/student-logo.png" class="student-logo">
    </header>
    <div class="flex-align-center">
      <div class="student-class-name flex-align-between">
        <div class="dot"></div>
        <div>{{ className }}</div>
        <div class="dot"></div>
      </div>
    </div>
    <div class="flex-align-between">
      <div class="tips-text">
        *选择自己的姓名并确认。
      </div>
      <div class="student-search flex-align">
        <div class="search-input">
          <input type="text" class="sc-input" @input="onInput" placeholder="输入姓名搜索">
          <img class="sc-ico" src="@/assets/student/search.png" alt="">
        </div>
        <button class="search-button" @click="searchName">搜索</button>
      </div>
    </div>
    <div class="student-list-container">
      <div class="student-grid">
        <!-- 'clicked': student.status == 1 -->
        <div v-for="(student, index) in studentList" :key="index" class="student-item default" :class="{
          'selected': student.status === 'selected',
          'clicked': student.status == 1
        }" @click="selectStudent(index, student)">
          <div class="student-name">{{ student.name }}</div>
          <div class="student-number">{{ student.userId }}</div>
        </div>
      </div>
      <!-- 确定按钮 -->
      <div class="confirm-section">
        <button class="confirm-btn" :disabled="selectedStudent === null" @click="confirmSelection">
          确定
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StudentClassMates",
  data() {
    return {
      className: '',
      numPages: null,
      selectedStudent: null,
      studentList: [],
      userId: null,
      classId: null,
      testId: null,
      teacherId: null,
      name: '',
      studentName: '',
      eventSource: null
    };
  },
  mounted() {
    this.classId = this.$route.query.classId;
    this.testId = this.$route.query.testId;
    this.teacherId = this.$route.query.teacherId;
    this.queryClassStatus();
    this.getStuList();
    // classId=30036&testId=35&teacherId=443213&t=1760237390232
    sessionStorage.setItem('padTestId', this.$route.query.testId);
    sessionStorage.setItem('padClassId', this.$route.query.classId);
    sessionStorage.setItem('padTeacherId', this.$route.query.teacherId);
    sessionStorage.setItem('padT', this.$route.query.t);
  },
  methods: {
    selectStudent(index, student) {
      console.log('index:', index, 'student:', student);
      // 如果该学生已经被其他同学点击过，则不允许点击
      if (student.status == 1) {
        this.$message({
          message: '该学生已被其他同学选择，无法再次选择',
          type: 'warning'
        });
        return;
      }
      // 如果已经选中了这个学生，则不允许再次点击
      if (this.selectedStudent === index) {
        this.$message({
          message: '该学生已被选中，无法重复选择',
          type: 'warning'
        });
        return;
      }
      // 如果已经选中了其他学生，先取消之前的选择
      if (this.selectedStudent !== null) {
        this.studentList[this.selectedStudent].status = 'default';
      }

      // 选中当前学生
      this.selectedStudent = index;
      this.studentList[index].status = 'selected';
      this.userId = student.userId;
      this.studentName = student.name;
      console.log('选择了学生:', student.name, '学号:', student.userId);
      this.$message({
        message: `已选择学生：${student.name}`,
        type: 'success'
      });
    },
    async confirmSelection() {
      if (this.selectedStudent === null) {
        this.$message({
          message: '请先选择学生',
          type: 'warning'
        });
        return;
      }
      const selectedStudent = this.studentList[this.selectedStudent];
      // 这里可以调用API提交选中的学生ID
      console.log('提交选中的学生:', {
        id: selectedStudent.userId, // 使用学号作为ID
        name: selectedStudent.name,
        index: this.selectedStudent
      });
      this.classIn();
      sessionStorage.setItem('padUserId', this.userId);
    },
    // 获取学生列表
    async getStuList() {
      let data = {
        testId: this.testId,
        classId: this.classId,
        name: this.name
      }
      let resData = await this.$Api.StuTest.stuList(data);
      console.log('学生列表数据:', resData);
      this.studentList = resData.data;
    },
    // 获取班级信息及测评状态
    async queryClassStatus() {
      let data = {
        testId: this.$route.query.testId,
      }
      let resData = await this.$Api.StuTest.queryClassStatus(data);
      console.log('班级信息及测评状态:', resData);
      this.className = resData.data.className;
    },
    // 搜索
    onInput(val) {
      this.name = val.target.value;
      this.selectedStudent = null;
      if (!val.target.value) {
        this.getStuList();
      }
    },
    searchName() {
      this.getStuList();
    },
    // 学生端上课
    async classIn() {
      // let data = {
      //   testId: this.testId,
      //   studentId: this.userId,
      // }
      let data = `testId=${this.testId}&studentId=${this.userId}`
      let resData = await this.$Api.StuTest.classIn(data);
      console.log('学生端上课:', resData);
      this.isUpload()
    },
    async isUpload() {
      let data = {
        studentId: this.userId,
        testId: this.testId,
      }
      let resData = await this.$Api.StuTest.queryStuUploadList(data);
      console.log('查询学生是否上传作品:', resData);
      this.selectedStudent = null;
      if (resData.data.length == 0) {
        this.$router.push({
          path: '/student/studentWork',
          query: {
            studentId: this.userId,
            classId: this.classId,
            teacherId: this.teacherId,
            testId: this.testId,
            className: this.className,
            studentName: this.studentName,
          }
        })
        sessionStorage.setItem('padClassName', this.className);
        sessionStorage.setItem('padStudentName', this.studentName);
      } else {
        this.$router.push({
          path: '/student/listWork',
          query: { studentId: this.userId, classId: this.classId, teacherId: this.teacherId, testId: this.testId },
        })
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "student.less";
</style>
<style></style>
